import { render } from "./TheMbRecieveButton.vue?vue&type=template&id=1500939f&scoped=true"
import script from "./TheMbRecieveButton.vue?vue&type=script&lang=js"
export * from "./TheMbRecieveButton.vue?vue&type=script&lang=js"

import "./TheMbRecieveButton.vue?vue&type=style&index=0&id=1500939f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1500939f"

export default script